import BaseService from "../BaseService";
import _ from "lodash";

class ProductService extends BaseService {
    list = async (filter) => {
        var data = await this._api.post("/product/list", filter);
        return data;
    };

    get = async (id) => {
        var data = await this._api.get(`/product/get`, { params: { id: id } });
        return data;
    };

    create = async (product) => {
        var data = await this._api.post(`/product/create`, product);
        return data;
    };

    delete = async (id) => {
        var data = await this._api.post(`/product/delete`, { id });
        return data;
    }

    hide = async (id) => {
        var data = await this._api.post(`/product/hide`, { id, hide: true });
        return data;
    }

    unhide = async (id) => {
        var data = await this._api.post(`/product/hide`, { id, hide: false });
        return data;
    }




    outOfStock = async (id, outOfStock = false) => {
        var data = await this._api.post(`/product/out_of_stock`, { id, out_of_stock: outOfStock });
        return data;
    }




    updateGeneralInfo = async (product) => {
        var data = await this._api.post(`/product/updategeneralinfo`, product);
        return data;
    };




}
export default ProductService;
